import { Dispatch, useCallback } from "react";
import { UnknownAction } from "redux-saga";
import { ticketGroupsActions } from "../../containers/Tickets/redux/slice";
import { TicketGroup } from "../../containers/Tickets/types";
import { useTicketCreateActions } from "../../containers/Tickets/useTicketCreateActions";
import { useBoardsActions } from "../useBoardsActions";

interface Props {
  dispatch:  Dispatch<UnknownAction>;
  params: Record<string, any>;
  group: TicketGroup;
  onCancel: () => void;
}

export default function useTicketHandlers({
  dispatch,
  params,
  group,
  onCancel,
}: Props) {
  const { fetchBoardsGroupsJson } = useBoardsActions(params.project as string);
  const { setTicketField } = useTicketCreateActions();
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;

    setTicketField("title", value);
  };

  const handleCreateTicket = () => {
    dispatch(
      ticketGroupsActions.setCreateTicket({
        projectId: params.project as string,
        boardId: params.boardId as string,
        groupId: group?._id,
        callback: () => {
          fetchBoardsGroupsJson(params.boardId as string);
        },
      }),
    );
  };

  const handleInputKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === "Enter") {
        e.preventDefault();
        handleCreateTicket();
      }
    },
    [handleCreateTicket],
  );
  const handleInputEscapeKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === "Escape") {
        onCancel();
      }
    },
    [onCancel],
  );

  return {
    handleChange,
    handleCreateTicket,
    handleInputKeyDown,
    handleInputEscapeKeyDown,
  };
}
